<div #divSpinner class="cargando" [style.display]="cargando ? '' : 'none'"><mat-spinner style="margin:0 auto; margin-top: 15%;" ></mat-spinner></div>


            <div class="row" style="position: absolute;top: 0;left: 0;right: 12px;height: 70px;background-color: rgba(89,124,238,0.3);z-index: 101;">
                <div class="col-sm-6">
                    
                </div>
                <div class="col-sm-6" style="text-align: right;">
                    <button type="button" (click)="volver()" class="btn btn-light btn-send" style="background-color: #FFDCE7;
                    color: #EE363D;
                    border: 1px solid;
                    width: 120px;
                    margin-top: 15px;
                    margin-right: 25px;
                    height: 40px;"> Volver</button>
                </div>
            </div>

<div class="embed-responsive embed-responsive-16by9" style="position: absolute;top: 0;left: 0;right: 0;bottom: 90px;overflow: auto;">
    <app-jardin [simulacion]="true"></app-jardin>
</div>
           